import React, { useState } from 'react';
import officeImage from '../careers/careersImage/office.webp';

const HeadquarterSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const faqs = [
    {
      question: "How do I apply at TekIT?",
      answer1: " Apply at TekIT by visiting our Careers page or emailing your CV to [hr@tekitsolution.com] with the subject “Application for [Job Title] – Your Name.",
      answer2: "Follow us on LinkedIn for the latest job openings and updates. ",
      answer3: "",
    },
    {
      question: "What is the hiring process at TekIT?",
      answer1: "Apply via TekIT’s Careers Page or email your resume to hr@tekitsolution.com.",
      answer2: "AShortlisted candidates undergo a technical assessment and HR interview as part of a smooth selection process.",
      answer3: "Selected applicants receive an offer and go through a seamless onboarding; follow our website and LinkedIn for updates.",
    },
    {
      question: "How do I get a job at TekIT?",
      answer1: "Apply via TekIT’s Careers Page or email your CV to hr@tekitsolution.com with the subject “Application for [Job Title] – Your Name.”",
      answer2: "Follow TekIT on LinkedIn (👉 linkedin.com/company/tekit-softwares) for job updates and company news.",
      answer3: "For a strong application, tailor your resume, include a cover letter, prepare for interviews, and don’t forget to follow up.",
    },
    {
      question: "Is it a work from office' opportunity?",
      answer1: "TekIT primarily follows a full work-from-office (WFO) model at our Indore location.",
      answer2: " However, based on project needs, select roles may offer work-from-home (WFH) options. Please check the specific job description ←- link—> or reach out to hr@tekitsolution.com for details.",
      answer3: "",
    },
    {
      question: "If there work opportunity in TekIT",
      answer1: "Yes, TekIT Software Solutions currently has multiple job openings across various roles and locations. They are actively hiring for all tech positions ",
      answer2: "For a comprehensive list of current openings, you can visit their Careers Page or check their LinkedIn Jobs Section. ",
      answer3: "If you need assistance tailoring your application or preparing for the interview, feel free to ask!",
    },
  ];
  return (
    <div className="max-w-8xl mx-auto lg:w-[84%]  px-8 lg:px-0 py-6">
      {/* <div className=" mx-auto lg:flex lg:items-start lg:justify-between gap-10">
        <div className="lg:w-1/2">
          <h2 className="lg:text-4xl text-[68px] font-bold text-black font-sans mb-4" data-aos="fade-up">Our Headquarter</h2>
          <p data-aos="fade-right" className="lg:text-[18px] text-[44px] font-medium mb-6 font-sans">
            Though we have a global presence, we are located at
          </p>

          <div data-aos="fade-left" className="text-gray-800 font-medium font-sans lg:text-[18px] text-[44px] leading-relaxed space-y-1 mb-4">
            <p>1110-Zion Z1,</p>
            <p>Sindhu Bhavan Marg,</p>
            <p>Bodakdev, Ahmedabad,</p>
            <p>Gujarat 380054, India</p>
          </div>

          <p data-aos="fade-up" className="text-red-500 font-medium lg:text-[17px] text-[44px] cursor-pointer mb-8 hover:underline">
            Direction to us
          </p>

          <div className="border hover:border-red-400 p-6 lg:ml-0 ml-28 rounded-md shadow-sm flex items-center gap-12 lg:gap-4 lg:max-w-md">
            <div className="text-red-500 lg:text-3xl text-[80px]">
              <i className="fas fa-headset"></i>
            </div>
            <div className=''>
              <h3 data-aos="fade-up" className="font-semibold lg:text-[18px] text-[44px] text-black">HR Inquiry</h3>
              <p data-aos="fade-up" className=" text-gray-700 lg:text-[16px] text-[34px]">hr@thinkwik.com</p>
              <p data-aos="fade-up" className=" text-gray-700 lg:text-[16px] text-[34px]">+91 988-831-8989 (IN)</p>
            </div>
          </div>
        </div>
        <div className="lg:w-1/2 mt-10 lg:mt-0">
          <img
            src={officeImage}
            alt="Headquarter Building"
            className="w-full rounded-lg shadow-md"
          />
        </div>
      </div> */}
      <div className="bg-[#fbfff8] px-4 py-4 lg:px-20 lg:py-12 font-recoleta">
        <h2 className="2xl:text-[40px] lg:text-[32px] text-[45px] font-bold text-center mb-10 mt-8" data-aos="fade-up">FAQs</h2>
        <div className="lg:max-w-4xl bg-[#f9f7ed] p-2 rounded-2xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              data-aos=""
              className={`bg-white rounded-2xl ${openIndex !== index  ?'hover:bg-blue-500 ':''}  shadow-md transition-all duration-300`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full  px-6 py-2 flex justify-between font-bold  text-center text-[34px] 2xl:text-[24px]  lg:text-[20px]"
              >
                <span>{faq.question}</span>
                <span className="text-xl text-center">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>
              {openIndex === index && (
               <>
                <div className="px-6 pb-4 2xl:text-[24px] hover:bg-white lg:text-[20px] text-[34px] text-gray-600">{faq.answer1}</div>
                <div className="px-6 pb-4 2xl:text-[24px] hover:bg-white lg:text-[20px] text-[34px] text-gray-600">{faq.answer2}</div>
                <div className="px-6 pb-4 2xl:text-[24px] hover:bg-white lg:text-[20px] text-[34px] text-gray-600">{faq.answer3}</div>
               </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeadquarterSection;
